const UtilsTypes = {
	SET_ERROR_PANEL: 'SET_ERROR_PANEL',
	SET_ALERT_MSG: 'SET_ALERT_MSG',
	SET_REDIRECT_URL: 'SET_REDIRECT_URL',
	SET_ERROR_MSG: 'SET_ERROR_MSG',
	HANDLE_BLOB_CHANGE: 'HANDLE_BLOB_CHANGE',
	ON_CLICK_REC: 'ON_CLICK_REC',
	SHOW_INSTRUCTION: 'SHOW_INSTRUCTION',
	HANDLE_VIDEO_BLOB_CHANGE: 'HANDLE_VIDEO_BLOB_CHANGE',
	SHOW_ERROR: 'SHOW_ERROR',
	SHOW_ECHO: 'SHOW_ECHO',
	SHOW_PERMIT_MIC: 'SHOW_PERMIT_MIC',
	SHOW_CONFIRM_NAME: 'SHOW_CONFIRM_NAME',
	RESET_AUDIO_BLOB: 'RESET_AUDIO_BLOB',
	UPDATE_PROFILE_DETAILS: {
		SUCCESS: 'UPDATE_PROFILE_DETAILS_SUCCESS',
		FAILURE: 'UPDATE_PROFILE_DETAILS_FAILURE',
		PENDING: 'UPDATE_PROFILE_DETAILS_PENDING',
	},

	MIC_TEST_RECORDING: {
		SUCCESS: 'MIC_TEST_RECORDING_SUCCESS',
		FAILURE: 'MIC_TEST_RECORDING_FAILURE',
		PENDING: 'MIC_TEST_RECORDING_PENDING',
	},

	POST_SPEECH_STATUS: {
		SUCCESS: 'POST_SPEECH_STATUS_SUCCESS',
		FAILURE: 'POST_SPEECH_STATUS_FAILURE',
		PENDING: 'POST_SPEECH_STATUS_PENDING',
	},
	UPDATE_RESET_COUNTER: 'UPDATE_RESET_COUNTER',
};

export default UtilsTypes;
